var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useCallback } from "react";
// Material ui Imports​
import { MenuOpenRounded } from "@mui/icons-material";
import { Drawer, Grid } from "@mui/material";
// Customer components imports (and hooks and helpers)
import VTButton from "./VTButton";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTNavBar use for web development to replace the material ui appBar
export default function VTSidePanel(_a) {
    var children = _a.children, _b = _a.anchor, anchor = _b === void 0 ? "left" : _b, _c = _a.defaultDrawerWidth, defaultDrawerWidth = _c === void 0 ? 240 : _c, _d = _a.minDrawerWidth, minDrawerWidth = _d === void 0 ? 50 : _d, _e = _a.maxDrawerWidth, maxDrawerWidth = _e === void 0 ? 1500 : _e, _f = _a.currentDrawWidth, currentDrawWidth = _f === void 0 ? 250 : _f, _g = _a.setCurrentDrawWidth, setCurrentDrawWidth = _g === void 0 ? function () { return null; } : _g, sx = _a.sx, _h = _a.sideMargin, sideMargin = _h === void 0 ? 0 : _h, _j = _a.drawOffSet, drawOffSet = _j === void 0 ? 0 : _j;
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var handleMouseDown = function (e) {
        document.addEventListener("mouseup", handleMouseUp, true);
        document.addEventListener("mousemove", handleMouseMove, true);
    };
    var handleMouseUp = function () {
        document.removeEventListener("mouseup", handleMouseUp, true);
        document.removeEventListener("mousemove", handleMouseMove, true);
    };
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    // Set the component width on drag based on size, collapses if bellow the min width
    var handleMouseMove = useCallback(function (e) {
        var newWidth = minDrawerWidth + 10;
        // If anchored left
        if (anchor === "left") {
            newWidth = e.clientX - drawOffSet - document.body.offsetLeft;
        }
        // If anchored Right
        else if (anchor === "right") {
            newWidth =
                document.body.clientWidth -
                    drawOffSet -
                    e.clientX -
                    document.body.offsetLeft;
        }
        // If anchored top
        else if (anchor === "top") {
            newWidth = e.clientY - drawOffSet - document.body.offsetTop;
        }
        // If anchored bottom
        else {
            newWidth =
                window.innerHeight -
                    drawOffSet -
                    e.clientY -
                    document.body.offsetTop;
        }
        // Collapses if bellow the min width
        if (newWidth > minDrawerWidth - 15 && newWidth < maxDrawerWidth) {
            if (newWidth < minDrawerWidth) {
                setCurrentDrawWidth(0);
            }
            else {
                setCurrentDrawWidth(newWidth);
            }
        }
    }, []);
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    return (_jsx(_Fragment, { children: currentDrawWidth != 0 ? (_jsxs(_Fragment, { children: [_jsx(Grid, { onMouseDown: function (e) { return handleMouseDown(e); }, sx: anchor === "left"
                        ? {
                            cursor: "ew-resize",
                            padding: "4px 0 0",
                            position: "fixed",
                            borderRadius: 20,
                            zIndex: 1205,
                            backgroundColor: "rgba(0,0,0,0)",
                            width: 15,
                            top: "calc(" +
                                sideMargin / 2 +
                                "px + 20%)",
                            bottom: "calc(-" +
                                sideMargin / 2 +
                                "px + 20%)",
                            ":hover": {
                                cursor: "grab",
                                backgroundColor: "#a9a9a9",
                            },
                            ":active": {
                                cursor: "grabbing",
                                backgroundColor: "#a9a9a9",
                            },
                            left: currentDrawWidth - 7.5 + drawOffSet,
                        }
                        : anchor === "right"
                            ? {
                                cursor: "ew-resize",
                                padding: "4px 0 0",
                                position: "fixed",
                                borderRadius: 20,
                                zIndex: 1205,
                                width: 15,
                                top: "20%",
                                bottom: "20%",
                                backgroundColor: "rgba(0,0,0,0)",
                                ":hover": {
                                    cursor: "grab",
                                    backgroundColor: "#a9a9a9",
                                },
                                ":active": {
                                    cursor: "grabbing",
                                    backgroundColor: "#a9a9a9",
                                },
                                right: currentDrawWidth - 7.5 + drawOffSet,
                            }
                            : anchor === "top"
                                ? {
                                    cursor: "n-resize",
                                    padding: "4px 0 0",
                                    position: "fixed",
                                    borderRadius: 20,
                                    zIndex: 1205,
                                    backgroundColor: "rgba(0,0,0,0)",
                                    height: 15,
                                    left: "20%",
                                    right: "20%",
                                    ":hover": {
                                        cursor: "grab",
                                        backgroundColor: "#a9a9a9",
                                    },
                                    ":active": {
                                        cursor: "grabbing",
                                        backgroundColor: "#a9a9a9",
                                    },
                                    top: currentDrawWidth - 7.5 + drawOffSet,
                                }
                                : {
                                    cursor: "n-resize",
                                    padding: "4px 0 0",
                                    position: "fixed",
                                    borderRadius: 20,
                                    zIndex: 1205,
                                    backgroundColor: "rgba(0,0,0,0)",
                                    height: 15,
                                    left: "calc(" +
                                        sideMargin / 2 +
                                        "px + 20%)",
                                    right: "calc(-" +
                                        sideMargin / 2 +
                                        "px + 20%)",
                                    ":hover": {
                                        cursor: "grab",
                                        backgroundColor: "#a9a9a9",
                                    },
                                    ":active": {
                                        cursor: "grabbing",
                                        backgroundColor: "#a9a9a9",
                                    },
                                    bottom: currentDrawWidth - 7.5 + drawOffSet,
                                } }), _jsx(Drawer, __assign({ variant: "permanent", anchor: anchor, sx: sx, PaperProps: {
                        style: anchor === "left"
                            ? {
                                width: currentDrawWidth,
                                position: "fixed",
                                top: "calc(" + sideMargin + "px + 0%)",
                                bottom: "0%",
                                left: drawOffSet,
                            }
                            : anchor === "right"
                                ? {
                                    width: currentDrawWidth,
                                    position: "fixed",
                                    top: "calc(" + sideMargin + "px + 0%)",
                                    bottom: "0%",
                                    right: drawOffSet,
                                }
                                : anchor === "bottom"
                                    ? {
                                        height: currentDrawWidth,
                                        position: "fixed",
                                        left: "calc(" + sideMargin + "px + 0%)",
                                        right: "0%",
                                        bottom: drawOffSet,
                                    }
                                    : {
                                        height: currentDrawWidth,
                                        position: "fixed",
                                        left: "calc(" + sideMargin + "px + 0%)",
                                        right: "0%",
                                        top: drawOffSet,
                                    },
                    }, onClose: function () { return setCurrentDrawWidth(0); } }, { children: children }))] })) : (_jsx(_Fragment, { children: _jsx(VTButton, __assign({ type: "icon", onClick: function () { return setCurrentDrawWidth(defaultDrawerWidth); }, sx: anchor === "left"
                    ? {
                        position: "fixed",
                        top: "46%",
                        left: "".concat(-75 + drawOffSet, "px"),
                        bottom: "47%",
                        minHeight: 50,
                        zIndex: 1400,
                        backgroundColor: "#a9a9a9",
                        transform: "rotate(180deg)",
                        transition: ".5s",
                        ":hover": {
                            cursor: "pointer",
                            boxShadow: "0 0 25px #2ad5c7",
                            backgroundColor: "#a9a9a9",
                        },
                    }
                    : anchor === "right"
                        ? {
                            position: "fixed",
                            top: "46%",
                            right: "".concat(-75 + drawOffSet, "px"),
                            bottom: "47%",
                            minHeight: 50,
                            zIndex: 1400,
                            backgroundColor: "#a9a9a9",
                            transition: ".5s",
                            ":hover": {
                                cursor: "pointer",
                                boxShadow: "0 0 25px #2ad5c7",
                                backgroundColor: "#a9a9a9",
                            },
                        }
                        : anchor === "top"
                            ? {
                                position: "fixed",
                                left: "46%",
                                top: "".concat(-45 + drawOffSet, "px"),
                                right: "47%",
                                minHeight: 50,
                                zIndex: 1400,
                                backgroundColor: "#a9a9a9",
                                transform: "rotate(270deg)",
                                transition: ".5s",
                                ":hover": {
                                    cursor: "pointer",
                                    boxShadow: "0 0 25px #2ad5c7",
                                    backgroundColor: "#a9a9a9",
                                },
                            }
                            : {
                                position: "fixed",
                                left: "46%",
                                bottom: "".concat(-45 + drawOffSet, "px"),
                                right: "47%",
                                minHeight: 50,
                                zIndex: 1400,
                                backgroundColor: "#a9a9a9",
                                transform: "rotate(90deg)",
                                transition: ".5s",
                                ":hover": {
                                    cursor: "pointer",
                                    boxShadow: "0 0 25px #2ad5c7",
                                    backgroundColor: "#a9a9a9",
                                },
                            } }, { children: _jsx(MenuOpenRounded, { sx: anchor === "left"
                        ? {
                            marginRight: 10,
                        }
                        : anchor === "right"
                            ? {
                                marginRight: 10,
                            }
                            : anchor === "top"
                                ? {
                                    marginRight: 10,
                                }
                                : {
                                    marginRight: 10,
                                } }) })) })) }));
}
